/**
 * 根据注册方式校验账号，校验通过后开启图形验证并进入验证码步骤。
 */
export function continueRegistrationVerification({
  loginType,
  validateMobile,
  validateEmail,
  showVerification,
  goToVerificationStep
}) {
  const validate = loginType === "MOBILE" ? validateMobile : loginType === "EMAIL" ? validateEmail : null;
  if (!validate) return;
  validate(valid => {
    if (!valid) return;
    showVerification();
    goToVerificationStep();
  });
}